// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Italicize = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Italicize = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Italicize = _exports.Italicize = function Italicize(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M8.42676 17L10.0631 7.18182H11.5716L9.93528 17H8.42676ZM11.2776 5.51989C10.9836 5.51989 10.73 5.41974 10.517 5.21946C10.3081 5.01918 10.2037 4.77841 10.2037 4.49716C10.2037 4.21591 10.3081 3.97514 10.517 3.77486C10.73 3.57457 10.9836 3.47443 11.2776 3.47443C11.5716 3.47443 11.8231 3.57457 12.0319 3.77486C12.2449 3.97514 12.3515 4.21591 12.3515 4.49716C12.3515 4.77841 12.2449 5.01918 12.0319 5.21946C11.8231 5.41974 11.5716 5.51989 11.2776 5.51989Z",
      fill: "currentColor"
    }));
  };
});
